import React from 'react';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  buttonRightIcon: {
    marginLeft: 4,
    fontSize: 20,
  }
});

function FilterButtonDropdown(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { classes, onSelect, items, filterArray } = props;

  function handleOpen(e) {
    setAnchorEl(e.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleMenuItemClick(item) {
    onSelect(item);
    handleClose();
  }
  
  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        size='small'
        onClick={handleOpen}
      >
        Predefined Filters
        <ArrowDropDownIcon className={classes.buttonRightIcon} />
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuList>
          {items.map((item) => {
            const isSelected = filterArray && filterArray.findIndex(el => el.filter === item.filter) > -1;
            return (
              item.separator
                ? <Divider key={'divider'}/>
                : <MenuItem
                    key={item.text}
                    selected={isSelected}
                    onClick={() => handleMenuItemClick(item)}
                  >
                    {item.text}
                  </MenuItem>
            )
          })}
        </MenuList>
      </Popover>
    </div>
  );
}

export default withStyles(styles)(FilterButtonDropdown);